import { render, staticRenderFns } from "./AuthBtn.vue?vue&type=template&id=0081eac5&"
import script from "./AuthBtn.vue?vue&type=script&lang=js&"
export * from "./AuthBtn.vue?vue&type=script&lang=js&"
import style0 from "./AuthBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports